<template>
  <b-modal
    centered
    scrollable
    static
    hide-footer
    title="Report Requests"
    no-close-on-backdrop
    header-bg-variant="primary"
    header-text-variant="gray"
    header-class="bg-white align-items-center"
    content-class="h-100"
    modal-class="reports-modal modal-fullscreen"
    v-model="editorShown"
    body-class="bg-extra-light-gray p-0"
  >
    <div class="iframe-container">
      <iframe :src="viewerUrl" frameBorder="0" class="h-100 w-100"></iframe>
    </div>
  </b-modal>
</template>

<script>
import { mapState } from "vuex";
import config from "../../server/serverCfg";

export default {
  name: "ReportRequestIndex",
  props: ["reportName", "reportFilters"],
  computed: {
    ...mapState("layout", {
      systemSetting: state => state.systemSetting
    }),
    viewerUrl() {
      return `${this.systemSetting.reportUrl}/#/report-requests/${
        config.token
      }?name=${this.reportName ? this.reportName : ""}&filters=${JSON.stringify(
        this.reportFilters
      )}`;
    },
    editorShown: {
      get() {
        return !!this.$attrs.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    }
  }
};
</script>

<style scoped>
.iframe-container {
  height: calc(100vh - 166px);
}
</style>
